<snelstart-ui-details
        [config]="detailsConfig"
        [entityId]="id"
        title="{{id}}"
>
    <snelstart-ui-details-buttons>
        <snelstart-ui-button type="primary"
                             class="me-2"
                             [config]="this.config()">
            Opslaan
        </snelstart-ui-button>

        <snelstart-ui-button *ngIf="showButtonInfo(id)"
                             type="secondary"
                             (click)="this.showDialogInfo()">
            Toelichting
        </snelstart-ui-button>
    </snelstart-ui-details-buttons>

    <snelstart-ui-details-content>
        <snelstart-venture-fiscaal-inhoudingsplichtige
                *ngIf="id ==='Inhoudingsplichtige'"></snelstart-venture-fiscaal-inhoudingsplichtige>
        <snelstart-venture-fiscaal-algemeen
                *ngIf="id ==='Vragen vooraf'"></snelstart-venture-fiscaal-algemeen>
        <snelstart-venture-fiscaal-contactgegevens
                *ngIf="id ==='Contactgegevens'"></snelstart-venture-fiscaal-contactgegevens>
        <snelstart-venture-fiscaal-inhoudingsvrijstelling
                *ngIf="id ==='Inhoudingsvrijstelling'"></snelstart-venture-fiscaal-inhoudingsvrijstelling>
        <snelstart-venture-fiscaal-opgaafdividend
                *ngIf="id ==='Inhoudingsvrijstelling buitenland'"></snelstart-venture-fiscaal-opgaafdividend>
        <snelstart-venture-fiscaal-normaaltarief
                *ngIf="id ==='Inhouding dividendbelasting'"></snelstart-venture-fiscaal-normaaltarief>
        <snelstart-venture-fiscaal-verdragstarief
                *ngIf="id ==='Inhouding dividendbelasting buitenland'"></snelstart-venture-fiscaal-verdragstarief>
        <snelstart-venture-fiscaal-bijzonderhedendividend
                *ngIf="id ==='Overige vragen'"></snelstart-venture-fiscaal-bijzonderhedendividend>
        <snelstart-venture-fiscaal-voorkomingdividend
                *ngIf="id ==='Afdrachtsvermindering'"></snelstart-venture-fiscaal-voorkomingdividend>
        <snelstart-venture-fiscaal-overzichtdividend
                *ngIf="id ==='Dividend en -belasting'"></snelstart-venture-fiscaal-overzichtdividend>
    </snelstart-ui-details-content>

    <snelstart-ui-dialog-definition id="specIB" title="Toelichting bij '{{id}}'"
                                    size="lg"
                                    [(visible)]="dialogInfoVisible">
        <snelstart-ui-dialog-body>
            <snelstart-venture-fiscaal-feature-tekst-div-inhoudingsplichtige
                    *ngIf="this.id ==='Inhoudingsplichtige'"></snelstart-venture-fiscaal-feature-tekst-div-inhoudingsplichtige>
            <snelstart-venture-fiscaal-feature-tekst-div-contactgegevens
                    *ngIf="this.id ==='Contactgegevens'"></snelstart-venture-fiscaal-feature-tekst-div-contactgegevens>
            <snelstart-venture-fiscaal-feature-tekst-div-vragen-vooraf
                    *ngIf="this.id ==='Vragen vooraf'"></snelstart-venture-fiscaal-feature-tekst-div-vragen-vooraf>
            <snelstart-venture-fiscaal-feature-tekst-div-met-inhouding-dividendbelasting
                    *ngIf="this.id ==='Inhouding dividendbelasting'"></snelstart-venture-fiscaal-feature-tekst-div-met-inhouding-dividendbelasting>
            <snelstart-venture-fiscaal-feature-tekst-div-met-inhoudingsvrijstelling
                    *ngIf="this.id ==='Inhoudingsvrijstelling'"></snelstart-venture-fiscaal-feature-tekst-div-met-inhoudingsvrijstelling>
            <snelstart-venture-fiscaal-feature-tekst-div-met-inhouding-dividendbelasting-buitenland
                    *ngIf="this.id ==='Inhouding dividendbelasting buitenland'"></snelstart-venture-fiscaal-feature-tekst-div-met-inhouding-dividendbelasting-buitenland>
            <snelstart-venture-fiscaal-feature-tekst-div-met-inhoudingsvrijstelling-buitenland
                    *ngIf="this.id ==='Inhoudingsvrijstelling buitenland'"></snelstart-venture-fiscaal-feature-tekst-div-met-inhoudingsvrijstelling-buitenland>
            <snelstart-venture-fiscaal-feature-tekst-div-overige-vragen
                    *ngIf="this.id ==='Overige vragen'"></snelstart-venture-fiscaal-feature-tekst-div-overige-vragen>
            <snelstart-venture-fiscaal-feature-tekst-div-dividendbelasting
                    *ngIf="this.id ==='Dividend en -belasting'"></snelstart-venture-fiscaal-feature-tekst-div-dividendbelasting>

            <!-- algemene informatie van Belastingdienst-->
            <div class="accordion" id="accordionExample">

                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingMeer">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseMeer" aria-expanded="false" aria-controls="collapseMeer">
                            Meer fiscale informatie
                        </button>
                    </h2>
                    <div id="collapseMeer" class="accordion-collapse collapse" aria-labelledby="headingMeer"
                         data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            Meer (algemene) informatie over de dividendbelasting vind je op de website van de Belastingdienst.

                            <div class="space20"></div>

                            <snelstart-ui-button size="small" type="secondary"
                                                 iconRight="arrow-up-right-from-square">

                                    <a target="_blank"
                                       href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/winst/dividendbelasting/">
                                        Fiscale informatie dividendbelasting
                                    </a>

                            </snelstart-ui-button>
                        </div>
                    </div>
                </div>
            </div>


        </snelstart-ui-dialog-body>

        <snelstart-ui-dialog-buttons class="d-flex mt-2">
            <snelstart-ui-button type="primary" icon="check" btn-x>Afsluiten
            </snelstart-ui-button>
        </snelstart-ui-dialog-buttons>
    </snelstart-ui-dialog-definition>

</snelstart-ui-details>
